import React from "react";
import Navbar from "../components/ui/Navbar";
import Footer from "../components/ui/Footer";
import { Card, CardContent, CardHeader } from "../components/ui/card";
import { LucideZap, LucideBarChart, LucideDatabase, LucideCloud, LucideServer, LucideShield } from "lucide-react";

const services = [
  {
    icon: <LucideZap className="h-10 w-10 text-blue-600" />,
    title: "Workflow Automation",
    description:
      "Streamline your business processes with our tailored workflow automation solutions to save time and reduce errors.",
  },
  {
    icon: <LucideBarChart className="h-10 w-10 text-blue-600" />,
    title: "Data Analytics",
    description:
      "Transform raw data into actionable insights with our data analytics services and customized dashboards.",
  },
  {
    icon: <LucideDatabase className="h-10 w-10 text-blue-600" />,
    title: "Database Management",
    description:
      "Optimize your database performance with scalable, secure, and reliable management solutions.",
  },
  {
    icon: <LucideCloud className="h-10 w-10 text-blue-600" />,
    title: "Cloud Solutions",
    description:
      "Leverage the power of the cloud to scale and innovate your business operations seamlessly.",
  },
  {
    icon: <LucideServer className="h-10 w-10 text-blue-600" />,
    title: "IT Infrastructure",
    description:
      "Build a robust and secure IT infrastructure with our end-to-end services tailored to your business needs.",
  },
  {
    icon: <LucideShield className="h-10 w-10 text-blue-600" />,
    title: "Cybersecurity",
    description:
      "Protect your business from evolving cyber threats with our cutting-edge cybersecurity solutions.",
  },
];

const ServicesPage = () => (
  <div className="flex flex-col min-h-screen bg-gray-50">
    <Navbar />
    <div className="flex-grow container mx-auto py-20 px-4">
      <h1 className="text-5xl font-bold text-center mb-10 text-blue-600">Our Services</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {services.map((service, index) => (
          <Card key={index} className="shadow-lg hover:shadow-xl transition-shadow duration-300">
            <CardHeader className="flex justify-center items-center p-6">{service.icon}</CardHeader>
            <CardContent className="p-4 text-center">
              <h3 className="text-xl font-bold mb-3 text-gray-800">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
    <Footer />
  </div>
);

export default ServicesPage;
